import React, { useState, useEffect } from "react";

const whatsappNumber = "5492996316836";
const whatsappUrl = `https://wa.me/${whatsappNumber}`;

// Verde de WhatsApp, oscurecido lo justo para que el texto blanco encima
// llegue a 5.0:1 de contraste. El verde de marca original daba 3.09:1.
const WHATSAPP_GREEN = "#15803D";
const WHATSAPP_GREEN_DARK = "#116430";

const buttonBaseStyle = {
  background: WHATSAPP_GREEN,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease",
  color: "white",
  textDecoration: "none",
  border: "none",
  gap: "10px",
  padding: "14px 28px",
  fontSize: "16px",
  fontWeight: "600",
  boxShadow: "0 6px 16px rgba(21, 128, 61, 0.28)",
};

const initialButtonStyle = {
  ...buttonBaseStyle,
  width: "min(320px, 80vw)",
  borderRadius: "9999px",
  opacity: 1,
  transform: "translateY(0)",
};

const floatingButtonStyle = {
  ...buttonBaseStyle,
  position: "fixed",
  bottom: 24,
  right: 24,
  zIndex: 9999,
  width: 60,
  height: 60,
  borderRadius: "50%",
  padding: 0,
};

const hoverStyle = {
  background: WHATSAPP_GREEN_DARK,
  transform: "translateY(-2px)",
  boxShadow: "0 10px 22px rgba(21, 128, 61, 0.36)",
};

const floatingHoverStyle = {
  background: WHATSAPP_GREEN_DARK,
  transform: "scale(1.08)",
  boxShadow: "0 12px 26px rgba(21, 128, 61, 0.42)",
};

const WhatsAppIcon = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 2C8.27812 2 2 8.27812 2 16C2 18.8375 2.875 21.4875 4.40625 23.7125L2.61562 29.5313L8.58437 27.7781C10.7219 29.1219 13.2656 29.9063 16 29.9063C23.7219 29.9063 30 23.7219 30 16C30 8.27812 23.7219 2 16 2ZM22.9813 20.7469C22.7 21.5188 21.5031 22.2031 20.5906 22.4094C19.9781 22.5469 19.1781 22.6531 16.4531 21.5344C12.9781 20.1125 10.7531 16.5781 10.5469 16.3094C10.3406 16.0406 9.15625 14.4469 9.15625 12.7938C9.15625 11.1406 10 10.3375 10.3375 9.97187C10.6125 9.67187 11.0094 9.54687 11.3875 9.54687C11.5312 9.54687 11.6594 9.55312 11.775 9.55937C12.0906 9.57187 12.2531 9.59062 12.4719 10.1719C12.7406 10.8875 13.4625 12.5406 13.5656 12.7469C13.6688 12.9531 13.7719 13.2219 13.625 13.4844C13.4844 13.7531 13.3594 13.8875 13.1531 14.125C12.9469 14.3625 12.7531 14.5469 12.5469 14.8C12.3563 15.0219 12.1375 15.2594 12.375 15.6531C12.6125 16.0406 13.3344 17.2219 14.3906 18.1656C15.7531 19.3844 16.8781 19.7875 17.3219 19.9781C17.6531 20.1219 18.0469 20.0906 18.2969 19.8094C18.6156 19.4469 19.0094 18.8563 19.4094 18.2719C19.6906 17.8531 20.0531 17.8063 20.4344 17.95C20.8219 18.0875 22.4688 18.8938 22.8844 19.1C23.3 19.3063 23.5781 19.4031 23.6813 19.5688C23.7844 19.7344 23.7844 20.4438 22.9813 20.7469Z" />
  </svg>
);

export default function WhatsAppButton({ showInitialButton = true }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100;
      if (scrolled !== isScrolled) {
        setIsScrolled(scrolled);
      }
    };

    let timeoutId = null;
    const throttledScroll = () => {
      if (timeoutId === null) {
        timeoutId = setTimeout(() => {
          handleScroll();
          timeoutId = null;
        }, 50);
      }
    };

    window.addEventListener("scroll", throttledScroll);
    return () => {
      window.removeEventListener("scroll", throttledScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isScrolled]);

  if (!showInitialButton && !isScrolled) {
    return null;
  }

  const getButtonStyle = () => {
    if (isScrolled) {
      return {
        ...floatingButtonStyle,
        ...(isHovered ? floatingHoverStyle : {}),
      };
    }

    return {
      ...initialButtonStyle,
      ...(isHovered ? hoverStyle : {}),
    };
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      style={getButtonStyle()}
      title="Escríbenos por WhatsApp"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <WhatsAppIcon size={isScrolled ? 32 : 24} />
      {!isScrolled && <span>Agendar turno</span>}
    </a>
  );
} 